module.exports = __webpack_public_path__ + "static/media/cover.8d5549f4.png";